<div class="wrap">
  <h3>{{data.title}}</h3>
  <p>{{data.text}}</p>

  <ng-container *ngIf="data.action === 'activateOrDeactivateFD' && data.form?.enabled">
    <p>
      <strong>Attention! Si vous désactivez ce formulaire, il ne sera plus possible de l'associer à un nouvel article.</strong>
    </p>
  </ng-container>

  <div class="btn_action">
    <ng-container *ngIf="data.action === 'exceedPlaceFree'; else elseTemplate">
      <button class="back" (click)="dialogRef.close()">Fermer</button>
    </ng-container>

    <ng-template #elseTemplate>
      <button class="back" (click)="dialogRef.close()">Annuler</button>
      <button class="confirm" (click)="confirmAction()" appChangeColorTheme attribute="bgc">Confirmer</button>
    </ng-template>
  </div>

</div>
